<script setup lang="ts">

import type { HTMLAttributes } from 'vue';

defineProps<{
  icons: string[],
  title?: string,
  selected?: boolean
  class?: HTMLAttributes['class'],
}>();
</script>
<template>
  <div
    :class="[
      'w-1',
      {
        'rounded-lg bg-(--color-sidebar-menu-selected-bg)': selected,
        'group-hover:bg-(--color-sidebar-menu-selected-bg)': !selected,
      },
    ]"
  />
  <div :class="['pl-3 flex items-center space-x-2 flex-1 pr-3 py-1.5']">
    <div>
      <UiFaIcon :icon="icons" />
    </div>
    <div>
      <slot name="title">
        {{ title }}
      </slot>
    </div>
  </div>
</template>
